import { Component,OnInit,OnDestroy,AfterViewInit,Pipe,PipeTransform, Input } from '@angular/core';
import { NgbModal,NgbActiveModal,ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { Subject } from 'rxjs';
import { FilterDateTime } from "src/app/shared/filter";

import { FvmsApiNoticeService } from "src/app/shared/service/fvms.api.notice.service";

@Component({
    selector: "notice-detail-popup"
    ,templateUrl: "./notice.detail.popup.component.html"
    ,providers: [FilterDateTime]
})
export class NoticeDetailPopupComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    noticeItem:any;

    constructor(
        public activeModal: NgbActiveModal
        ,private fvmsApiNoticeService:FvmsApiNoticeService
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    @Input()
    set inputNoticeItem(noticeItem:any){
        if(noticeItem){
            this.noticeItem = noticeItem;
            noticeItem.content = decodeURIComponent(noticeItem.content);
            this.updateViewCount();
        }
    }

    clickCancel(){
        this.activeModal.close({
            "type":"cancel"
        });
    }

    parseContent(content){
        return decodeURIComponent(content);
    }

    updateViewCount(){
        this.fvmsApiNoticeService.updateViewCount(this.noticeItem.noticeId)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                console.log("updateViewCount",response);
            });
    }
}